import React, {useState} from "react";
import { Row, Col, Table, TabContent, TabPane, Input } from "reactstrap";
import { TextField, Button } from "@mui/material";

import SnackBar from "../components/snackbar";
import BreadCrumb from "../components/breadcrumb";
import TabHeader from "../components/tab_header";
import LocationCard from "../components/card_order/location_card";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import CustomMap from "../components/map/custom_map";
import RadioButton from "../components/radio";
import { convertDate, formatCurrency } from "../helpers/utils";
const CardOrder = () => {

  const [step, setStep] = useState(0)
  const [active, setActive] = useState(0)
  const [paymentStep, setPaymentActive] = useState(0)
  const [rSelected, setRSelected] = useState(false);
  const [showMessage, setShowMessage] = useState(false)
  const openMessage = () => setShowMessage(true)
  const closeMessage = () => setShowMessage(false)
  const center = { lat: -34.397, lng: 150.644 };
  const zoom = 4;

  const render = (status) => {
    if (status === Status.LOADING) { console.log('map loading') }; 
    if (status === Status.FAILURE) { console.log('map stats') };
    return null;
  };

  const charge = () => {
    setStep(0)
    setActive(0)
    setPaymentActive(0)
    setRSelected(false)
    openMessage();
  }

  return (
    <>
      <BreadCrumb 
          active={step}
          paths={[
            'Захиалгын мэдээлэл', 'Байршил сонгох', 'Төлбөр төлөлт'
          ]}
        />
      <div className="page-content">
        {
          step === 0 && 
          <Row className="p-4 p-xxl-5 justify-content-between">
            <Col lg={5} md={9}>
              <p className="font-size-16 font-weight-bold ps-3">
                  Байгууллагын мэдээлэл
              </p>
              
              <div>
                <div className="mt-4">
                    <div className="font-size-12 text-grey">РЕГИСТРИЙН ДУГААР</div>
                    <div className="font-size-16 font-weight-500">1849201</div>
                </div>
                <div className="mt-2">
                    <div className="font-size-12 text-grey">БАЙГУУЛЛАГЫН НЭР</div>
                    <div className="font-size-16 font-weight-500">Прокрафт Дизайн Агентлаг</div>
                </div>
              </div>
  
              <Row className="mt-4">
                <Col lg={6} md={6} xs={6}>
                  <TextField 
                      className="mb-2 w-100" 
                      label="И-мэйл" 
                      variant="outlined"></TextField>
                </Col>
                <Col lg={6} md={6} xs={6}>
                  <TextField
                      className="mb-2 w-100" 
                      label="Утасны дугаар" 
                      variant="outlined"></TextField>
                </Col>
              </Row>
  
              <TextField 
                  className="mt-2 mb-2 w-100" 
                  label="Нэмэлт мэдээлэл" 
                  variant="outlined"></TextField>
  
              <div>
                <p className="font-size-16 mt-4 font-weight-bold ps-3">
                  И-Баримт хүлээн авах мэйл
                </p>
                <TextField 
                    className="mb-2 w-100" 
                    label="Мэйл" 
                    variant="outlined"></TextField>
              </div>
  
              <div>
                <p className="font-size-16 mt-4 font-weight-bold ps-3">
                  Захиалах картын тоон хэмжээ
                </p>
                <TextField 
                    className="mb-2 w-100" 
                    label="Картын тоо" 
                    variant="outlined"></TextField>
              </div>
  
              <div className="d-flex justify-content-end">
                <Button 
                  onClick={() => setStep(1)}
                  className="bg-primary btn-bordered w-100 w-sm-auto mt-4" 
                  variant="contained"
                  disableElevation>
                  Үргэлжлүүлэх
                </Button>
              </div>
            </Col>
  
            <Col lg={6} md={9} className="mb-md-5 mb-2">
              <p className="font-size-16 font-weight-bold ps-3 mt-4 mt-lg-0">
                  Карт захиалгын түүх
              </p>
  
              <Table bordered>
                <thead className="font-size-14">
                  <tr>
                    <th>Огноо</th>
                    <th>Тоо, Ширхэг</th>
                    <th>Нийт мөнгөн дүн</th>
                    <th>Төлөв</th>
                  </tr>
                </thead>
  
                <tbody className="font-size-14 text-grey">
                  <tr>
                    <th>{convertDate(new Date)}</th>
                    <th>5</th>
                    <th>{formatCurrency(25000)}</th>
                    <th>
                      <div className="d-flex align-items-center">
                        <div className="tb-dot bg-success ms-2"></div> 
                        Хүлээн авсан
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th>{convertDate(new Date)}</th>
                    <th>5</th>
                    <th>{formatCurrency(25000)}</th>
                    <th>
                      <div className="d-flex align-items-center">
                        <div className="tb-dot bg-error ms-2"></div> 
                        Хүлээн аваагүй
                      </div>
                    </th>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        }
        {
          step === 1 && <div className="p-4 p-xxl-5">
            <TabHeader
              chargeType={active}
              setChargeType={setActive}
              items={['Шунхлай картын төв', 'Ойрхон байрлаж буй ШТС', 'Өөрийн хаяг дээр хүргүүлэх']}/>
            <TabContent activeTab={active} className="py-4">
              <TabPane tabId={0} className="col-12 col-md-6 col-lg-4">
                <p className="font-size-16 font-weight-bold ps-3">
                    Картын төв сонгох
                </p>
                <div className="mt-2" onClick={() => setRSelected(false)}>
                  <RadioButton checked={!rSelected} className="p-1"/>
                  <label className="form-check-label font-weight-500 pt-1" htmlFor="inlineRadio1"><p className="px-2 m-0">Шунхлай картын төв 1</p></label>
                </div>
                <div className="" onClick={() => setRSelected(true)}>
                  <RadioButton checked={rSelected} className="p-1"/>
                  <label className="form-check-label font-weight-500" htmlFor="inlineRadio2"><p className="px-2 m-0">Шунхлай картын төв 2</p></label>
                </div>
  
                <div>
                  <p className="font-size-16 mt-4 font-weight-bold ps-3">
                    И-Баримт хүлээн авах мэйл
                  </p>
                  <TextField 
                      className="mb-2 w-100" 
                      label="Мэйл" 
                      variant="outlined"></TextField>
                </div>
  
                <div className="d-flex justify-content-end">
                  <Button 
                    onClick={() => setStep(2)}
                    className="bg-primary btn-bordered w-100 w-sm-auto mt-4" 
                    variant="contained"
                    disableElevation>
                    Үргэлжлүүлэх
                  </Button>
                </div>
  
              </TabPane>
              <TabPane tabId={1}>
                <div className="d-lg-flex justify-content-between align-content-center d-none">
                  <div className="d-flex flex-wrap gap-2">
                    <div className="select custom-select">
                      <Input
                        className="py-2 px-3 custom-dropdown"
                        type="select"
                        placeholder=""
                      >
                        <option value="" defaultValue disabled>Хот, Аймаг</option>
                        <option>
                          Default Select 1
                        </option>
                      </Input>
                    </div>
                    <div className="select custom-select">
                      <Input
                        className="py-2 px-3 custom-dropdown"
                        type="select"
                        placeholder=""
                      >
                        <option className="text-disabled" value="" defaultValue disabled>Дүүрэг, Сум</option>
                        <option>
                          Default Select 1
                        </option>
                      </Input>
                    </div>
                    <div className="select custom-select">
                      <Input
                        className="py-2 px-3 custom-dropdown"
                        type="select"
                        placeholder=""
                      >
                        <option className="text-disabled" value="" defaultValue disabled>Баг, Хороо</option>
                        <option>
                          Default Select 1
                        </option>
                      </Input>
                    </div>
                  </div>
                  <a className="my-auto text-grey" href="#">
                    Шүүлтүүр устгах
                  </a>
                </div>
                <div className="d-sm-none d-block mt-0">
                  <p className="font-size-16 font-weight-bold ps-3">
                    Сонгох
                  </p>
                  <Button
                    className="btn-bordered btn-bordered-white w-100 w-sm-auto px-9 mt-1 mx-sm-0"
                    variant="contained"
                    disableElevation
                    onClick={() => setStep(2)}
                    startIcon={<img alt="pin" src="/images/pin_drop.svg" height={16} />}
                  >
                    <span className="font-weight-500">Байршил сонгох</span>
                  </Button>
                  <Button 
                    onClick={() => setStep(2)}
                    className="bg-primary btn-bordered w-100 w-sm-auto mt-4" 
                    variant="contained"
                    disableElevation>
                    Үргэлжлүүлэх
                  </Button>
                </div>
                <div className="d-sm-block mt-4 border border-grey rounded d-none">
                  <div className="row">
                    <div className="col-4">
                      <LocationCard></LocationCard>
                      <LocationCard></LocationCard>
                      <LocationCard></LocationCard>
                      <LocationCard></LocationCard>
                    </div>
                    <div className="col-8 h-full">
                      <div className="bg-primary w-full" style={{height:'100%'}}>
                        <Wrapper apiKey={"AIzaSyCQzg_dNMu26Setxf42hyHxERNaHztzwtY"} render={render}>
                          <CustomMap center={center} zoom={zoom}></CustomMap>
                        </Wrapper>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId={2}>
                <div className="row">
                  <div className="col-12 col-md-10 col-lg-6">
                    <p className="font-size-16 mt-2 font-weight-bold">
                      Хүргүүлэх хаяг
                    </p>
                    <Row className="mt-0 px-2">
                      <Col lg={4} md={4} sm={12} className="px-1 mb-3 mb-md-0 ps-md-3">
                        <div className="w-100">
                            <Input
                              id="duureg"
                              type="select"
                              className="px-3 custom-dropdown">
                              <option className="text-disabled" value="" disabled>Дүүрэг, Сум</option>
                              <option>
                                Default Select 1
                              </option>
                            </Input>
                        </div>
                      </Col>
                      <Col lg={4} md={4} sm={12} className="px-1 mb-3 mb-md-0 ps-md-3">
                        <Input
                          id="duureg"
                          type="select"
                          className="py-2 px-3 custom-dropdown">
                          <option className="text-disabled" value="" disabled>Дүүрэг, Сум</option>
                          <option>
                            Default Select 1
                          </option>
                        </Input>
                      </Col>
                      <Col lg={4} md={4} sm={12} className="px-1 ps-md-0">
                        <Input
                          id="duureg"
                          type="select"
                          className="py-2 px-3 custom-dropdown">
                          <option className="text-disabled" value="" disabled>Дүүрэг, Сум</option>
                          <option>
                            Default Select 1
                          </option>
                        </Input>
                      </Col>
                    </Row>
                    <Row className="mt-3 px-2">
                      <Col lg={6} md={6} xs={6} className="px-1 ps-md-3">
                        <TextField 
                            className="mb-2 w-100" 
                            label="Хороолол" 
                            variant="outlined"></TextField>
                      </Col>
                      <Col lg={6} md={6} xs={6} className="px-1 ps-md-0">
                        <TextField
                            className="mb-2 w-100" 
                            label="Гудамж" 
                            variant="outlined"></TextField>
                      </Col>
                    </Row>
                    <Row className="mt-2 px-2">
                      <Col lg={6} md={6} xs={6} className="px-1 ps-md-3">
                        <TextField 
                            className="mb-2 w-100" 
                            label="Байр" 
                            variant="outlined"></TextField>
                      </Col>
                      <Col lg={6} md={6} xs={6} className="px-1 ps-md-0">
                        <TextField
                            className="mb-2 w-100" 
                            label="Орц" 
                            variant="outlined"></TextField>
                      </Col>
                    </Row>
                    <Row className="mt-2 px-2">
                      <Col lg={6} md={6} xs={6} className="px-1 ps-md-3">
                        <TextField 
                            className="mb-2 w-100" 
                            label="Давхар" 
                            variant="outlined"></TextField>
                      </Col>
                      <Col lg={6} md={6} xs={6} className="px-1 ps-md-0">
                        <TextField
                            className="mb-2 w-100" 
                            label="Хаалганы дугаар" 
                            variant="outlined"></TextField>
                      </Col>
                    </Row>
                    <p className="font-size-16 mt-5 font-weight-bold">
                      Нэмэлт мэдээлэл
                    </p>
                    <Row className="mt-0">
                      <Col lg={12} md={12} sm={12}>
                        <TextField 
                            className="mb-2 w-100" 
                            label="Тайлбар" 
                            variant="outlined"></TextField>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col lg={12} md={12} sm={12}>
                        <div className="d-flex justify-content-between mt-4">
                          <div className="">
                              <div className="font-size-14 text-grey">Хүргэлтийн төлбөр</div>
                              <div className="font-size-16 font-weight-bold">2000₮</div>
                          </div>
                          <Button 
                            onClick={() => setStep(2)}
                            className="bg-primary btn-bordered" 
                            variant="contained"
                            disableElevation>
                            Үргэлжлүүлэх
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
        }
        {
          step === 2 && paymentStep === 0 && <div className="my-2 my-md-5 mx-2 mx-md-5">
            <div className="row">
              <div className="col-12 col-md-7 col-lg-5 px-4 px-md-3 px-lg-5 py-4 py-md-0 py-lg-3">
                <p className="font-size-16 font-weight-bold">Байгууллагын мэдээлэл</p>
                <div className="bordered bg-light p-3 mt-4">
                  <div className="d-flex justify-content-between">
                    <div className="font-size-14 text-grey my-1 ms-4">Байгууллагын нэр</div>
                    <div className="font-size-14 font-weight-bold my-1 text-end">Procraft design agency</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="font-size-14 text-grey my-1 ms-4">Байгууллагын регистр</div>
                    <div className="font-size-14 font-weight-bold my-1 text-end">456789</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="font-size-14 text-grey my-1 ms-4">И-Мэйл хаяг</div>
                    <div className="font-size-14 font-weight-bold my-1 text-end">test@gmail.com</div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="font-size-14 text-grey my-1 ms-4">Утасны дугаар</div>
                    <div className="font-size-14 font-weight-bold my-1 text-end">9999-9999</div>
                  </div>
                </div>
                <div className="bordered border-bottom-0 raduis-bottom-0 bg-transparent-link p-3 mt-5">
                  <a href="#" onClick={() => setPaymentActive(1)}>
                    <div className="d-flex justify-content-between align-content-center">
                      <div>
                          <div className="font-size-16 font-weight-bold">Толгой картаар төлөх</div>
                          <div className="font-size-14 text-grey">
                              Байгууллага дээр та карт захиалах бол энд дарж үргэлжлүүлнэ үү.
                          </div>
                      </div>
                      <img className="p-3" src="/images/arrow_next.svg" />
                    </div>
                  </a>
                </div>
                <div className="bordered-sharp bg-transparent-link p-3">
                  <a href="#" onClick={() => setPaymentActive(2)}>
                    <div className="d-flex justify-content-between align-content-center">
                      <div>
                          <div className="font-size-16 font-weight-bold">Дансаар төлөх</div>
                          <div className="font-size-14 text-grey">
                              Байгууллага дээр та карт захиалах бол энд дарж үргэлжлүүлнэ үү.
                          </div>
                      </div>
                      <img className="p-3" src="/images/arrow_next.svg" />
                    </div>
                  </a>
                </div>
                <div className="bordered border-top-0 raduis-top-0 bg-transparent-link p-3">
                  <a href="#" onClick={() => setPaymentActive(3)}>
                    <div className="d-flex justify-content-between align-content-center">
                      <div>
                          <div className="font-size-16 font-weight-bold">Шуурхай төлөлт</div>
                          <div className="font-size-14 text-grey">
                              Байгууллага дээр та карт захиалах бол энд дарж үргэлжлүүлнэ үү.
                          </div>
                      </div>
                      <img className="p-3" src="/images/arrow_next.svg" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        } 
        {
          step === 2 && <div className="my-2 mx-2 mx-md-4">
            { paymentStep != 0 && <div className="d-block d-lg-none px-3 px-md-0 pt-2">
              <div className="d-flex align-items-center">
                <div>
                  <a href="#" onClick={() => setPaymentActive(0) }><img className="p-2 bordered bg-transparent-link rounded-circle" src="/images/arrow_back_ios.svg" width="40px"></img></a>
                </div>
                <div className="m-3 font-size-16 font-weight-bold">
                  { paymentStep === 1 && "Толгой картаар төлөх" }
                  { paymentStep === 2 && "Дансаар төлөх" }
                  { paymentStep === 3 && "Дансаар төлөх" }
                </div>
              </div>
              <div className="font-size-20 font-weight-bold mt-0 pt-5">
                { paymentStep === 1 && "Толгой картын мэдээлэл" }
                { paymentStep === 2 && "Төлбөр хийгдэх данс" }
                { paymentStep === 3 && "Төлбөр хийгдэх данс" }
              </div>
            </div>}
            <Row className="px-3 px-md-0 px-lg-5 py-1 py-md-1 py-lg-3 justify-content-between">
              <Col lg={5} md={6} sm={6}>
                {
                  paymentStep === 1 && <div>
                    <div className="d-none d-lg-block">
                      <div className="d-flex align-items-center">
                        <div>
                          <a href="#" onClick={() => setPaymentActive(0) }><img className="p-2 bordered bg-transparent-link rounded-circle" src="/images/arrow_back_ios.svg" width="40px"></img></a>
                        </div>
                        <div className="m-3 font-size-16 font-weight-bold">Толгой картаар төлөх</div>
                      </div>
                      <div className="font-size-20 font-weight-bold mt-0 mt-md-3 pt-4">Толгой картын мэдээлэл</div>
                    </div>

                    <div className="bordered border-bottom-0 raduis-bottom-0 bg-light p-3 mt-4">
                      <div className="mb-4">
                          <div className="font-size-12 text-grey">МАСТЕР КАРТЫН ҮЛДЭГДЭЛ</div>
                          <div className="font-size-18 font-weight-bold text-secondary">2’000’000₮</div>
                      </div>
                      <Row>
                        <Col lg={6} md={6} xs={6}>
                          <div className="">
                              <div className="font-size-12 text-grey">КАРТЫН ДУГААР</div>
                              <div className="font-size-16 font-weight-bold">5098 0998 7584</div>
                          </div>
                        </Col>
                        <Col lg={6} md={6} xs={6}>
                          <div className="">
                              <div className="font-size-12 text-grey">ЭЗЭМШИГЧ</div>
                              <div className="font-size-16 font-weight-bold">Билгүүн Мөнхбат</div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="bordered raduis-top-0 bg-light p-3">
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Байгууллагын нэр</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">Procraft design agency</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Байгууллагын регистр</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">456789</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">И-Мэйл хаяг</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">test@gmail.com</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Утасны дугаар</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">9999-9999</div>
                      </div>
                    </div>
                    
                    <div className="font-size-16 font-weight-bold mt-5">Төлбөр хийгдэх данс</div>
                    <div className="bordered bg-light p-3 mt-4">
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Дансны дугаар</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">5069090590</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Хүлээн авах банк</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">Хаан Банк</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Хүлээн авагч</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">Шунхлай</div>
                      </div>
                    </div>

                    <div className="font-size-16 font-weight-bold mt-5">Байршил болон мэдээлэл</div>
                    <div className="bordered raduis-top-0 p-3 mt-4 d-flex justify-content-between">
                        <div>
                          <div className="font-size-14 font-weight-bold my-1">Шунхлай төв оффис</div>
                          <div className="font-size-14 text-grey my-1">Хан-уул дүүрэг, 15-р хороо, APU барилга, 1-р давхар, 0000 тоот, 2-р өрөө</div>
                          <div className="d-flex flex-wrap mt-2">
                            <a href="#" className="font-size-12 ms-2"><span className="text-grey">#</span>АИ-92 - ₮4’200</a>
                            <a href="#" className="font-size-12 ms-2"><span className="text-grey">#</span>А-80 - ₮4’200</a>
                            <a href="#" className="font-size-12 ms-2"><span className="text-grey">#</span>ДТ</a>
                          </div>
                        </div>
                        <div className="me-3">
                          <img src="/images/location.svg" width="25px"></img>
                        </div>
                    </div>
                    <div className="bordered raduis-top-0 p-3 mt-3">
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Нэгж үнэ:</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">5’000₮</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Хүргэлтийн үнэ:</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">10’000₮</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Захиалсан картын тоо:</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">3</div>
                      </div>
                      <div className="d-flex justify-content-between text-primary">
                        <div className="font-size-14 font-weight-bold text-primary my-1 ms-4">Нийт дүн:</div>
                        <div className="font-size-14 font-weight-bold text-primary my-1 text-end">25’000₮</div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end mt-5">
                      <Button 
                        onClick={() => charge()}
                        className="bg-primary btn-bordered w-100 w-sm-auto" 
                        variant="contained"
                        disableElevation>
                        Захиалга өгөх
                      </Button>
                    </div>
                  </div>
                }
                {
                  paymentStep === 2 && <div>
                    <div className="d-none d-lg-block">
                      <div className="d-flex align-items-center">
                        <div>
                          <a href="#" onClick={() => setPaymentActive(0) }><img className="p-2 bordered bg-transparent-link rounded-circle" src="/images/arrow_back_ios.svg" width="40px"></img></a>
                        </div>
                        <div className="m-3 font-size-16 font-weight-bold">Дансаар төлөх</div>
                      </div>
                      <div className="font-size-20 font-weight-bold mt-0 mt-md-3 pt-4">Төлбөр хийгдэх данс</div>
                    </div>
                    <div className="bordered border-bottom-0 raduis-bottom-0 bg-light p-3 mt-4">
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Байгууллагын нэр</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">Procraft design agency</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Байгууллагын регистр</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">456789</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">И-Мэйл хаяг</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">test@gmail.com</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Утасны дугаар</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">9999-9999</div>
                      </div>
                    </div>
                    <div className="bordered border-bottom-0 raduis-top-0 raduis-bottom-0  bg-light p-4 text-center">
                      <div className="font-size-14 font-weight-bold mb-3"> QR кодыг<br></br> уншуулан төлөөрэй</div>
                      <img width="110px" src="/images/qr.png"></img>
                    </div>
                    <div className="bordered raduis-top-0 bg-light p-4 d-flex align-items-start">
                      <img width="24px" src="/images/info.svg"></img>
                      <div className="font-size-14 font-weight-bold me-3">Та гүйлгээний утган дээр өөрийн утас болон худалдан авсан картын тоогоо оруулж өгнө үү.</div>
                    </div>

                    <div className="font-size-16 font-weight-bold mt-5">Байршил болон мэдээлэл</div>
                    <div className="bordered raduis-top-0 p-3 mt-4 d-flex justify-content-between">
                        <div>
                          <div className="font-size-14 font-weight-bold my-1">Шунхлай төв оффис</div>
                          <div className="font-size-14 text-grey my-1">Хан-уул дүүрэг, 15-р хороо, APU барилга, 1-р давхар, 0000 тоот, 2-р өрөө</div>
                          <div className="d-flex flex-wrap mt-2">
                            <a href="#" className="font-size-12 ms-2"><span className="text-grey">#</span>АИ-92 - ₮4’200</a>
                            <a href="#" className="font-size-12 ms-2"><span className="text-grey">#</span>А-80 - ₮4’200</a>
                            <a href="#" className="font-size-12 ms-2"><span className="text-grey">#</span>ДТ</a>
                          </div>
                        </div>
                        <div className="me-3">
                          <img src="/images/location.svg" width="25px"></img>
                        </div>
                    </div>
                    <div className="bordered raduis-top-0 p-3 mt-3">
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Нэгж үнэ:</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">5’000₮</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Хүргэлтийн үнэ:</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">10’000₮</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Захиалсан картын тоо:</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">3</div>
                      </div>
                      <div className="d-flex justify-content-between text-primary">
                        <div className="font-size-14 font-weight-bold text-primary my-1 ms-4">Нийт дүн:</div>
                        <div className="font-size-14 font-weight-bold text-primary my-1 text-end">25’000₮</div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end mt-5">
                      <Button 
                        onClick={() => charge()}
                        className="bg-primary btn-bordered w-100 w-sm-auto" 
                        variant="contained"
                        disableElevation>
                        Захиалга өгөх
                      </Button>
                    </div>
                  </div>
                }
                {
                  paymentStep === 3 && <div>
                    <div className="d-none d-lg-block">
                      <div className="d-flex align-items-center">
                        <div>
                          <a href="#" onClick={() => setPaymentActive(0) }><img className="p-2 bordered bg-transparent-link rounded-circle" src="/images/arrow_back_ios.svg" width="40px"></img></a>
                        </div>
                        <div className="m-3 font-size-16 font-weight-bold">Дансаар төлөх</div>
                      </div>
                      <div className="font-size-20 font-weight-bold mt-0 mt-md-3 pt-4">Төлбөр хийгдэх данс</div>
                    </div>

                    <div className="bordered bg-light p-3 mt-4">
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Байгууллагын нэр</div>
                        <div className="font-size-14 font-weight-bold text-end">Procraft design agency</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Байгууллагын регистр</div>
                        <div className="font-size-14 font-weight-bold text-end">456789</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">И-Мэйл хаяг</div>
                        <div className="font-size-14 font-weight-bold text-end">test@gmail.com</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Утасны дугаар</div>
                        <div className="font-size-14 font-weight-bold text-end">9999-9999</div>
                      </div>
                    </div>
                    
                    <div className="font-size-16 font-weight-bold mt-5">Gateway</div>
                    <div className="d-flex flex-wrap mt-4">
                      <a href="#" className="bordered bg-transparent-link p-2 p-md-2 ms-1 ms-md-1">
                        <img src="/images/bank1.svg" width="48px"></img>
                      </a>
                      <a href="#" className="bordered bg-transparent-link p-2 p-md-2 ms-1 ms-md-1">
                        <img src="/images/bank2.svg" width="48px"></img>
                      </a>
                      <a href="#" className="bordered bg-transparent-link p-2 p-md-2 ms-1 ms-md-1">
                        <img src="/images/bank3.svg" width="48px"></img>
                      </a>
                    </div>
                    <div className="d-flex flex-wrap mt-3">
                      <a href="#" className="bordered bg-transparent-link p-2 p-md-2 ms-1 ms-md-1">
                        <img src="/images/bank4.svg" width="48px"></img>
                      </a>
                      <a href="#" className="bordered bg-transparent-link p-2 p-md-2 ms-1 ms-md-1">
                        <img src="/images/bank5.svg" width="48px"></img>
                      </a>
                      <a href="#" className="bordered bg-transparent-link p-2 p-md-2 ms-1 ms-md-1">
                        <img src="/images/bank6.png" width="48px"></img>
                      </a>
                    </div>

                    <div className="font-size-16 font-weight-bold mt-5">Байршил болон мэдээлэл</div>
                    <div className="bordered raduis-top-0 p-3 mt-4 d-flex justify-content-between">
                        <div>
                          <div className="font-size-14 font-weight-bold my-1">Шунхлай төв оффис</div>
                          <div className="font-size-14 text-grey my-1">Хан-уул дүүрэг, 15-р хороо, APU барилга, 1-р давхар, 0000 тоот, 2-р өрөө</div>
                          <div className="d-flex flex-wrap mt-2">
                            <a href="#" className="font-size-12 ms-2"><span className="text-grey">#</span>АИ-92 - ₮4’200</a>
                            <a href="#" className="font-size-12 ms-2"><span className="text-grey">#</span>А-80 - ₮4’200</a>
                            <a href="#" className="font-size-12 ms-2"><span className="text-grey">#</span>ДТ</a>
                          </div>
                        </div>
                        <div className="me-3">
                          <img src="/images/location.svg" width="25px"></img>
                        </div>
                    </div>
                    <div className="bordered raduis-top-0 p-3 mt-3">
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Нэгж үнэ:</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">5’000₮</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Хүргэлтийн үнэ:</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">10’000₮</div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div className="font-size-14 text-grey my-1 ms-4">Захиалсан картын тоо:</div>
                        <div className="font-size-14 font-weight-bold my-1 text-end">3</div>
                      </div>
                      <div className="d-flex justify-content-between text-primary">
                        <div className="font-size-14 font-weight-bold text-primary my-1 ms-4">Нийт дүн:</div>
                        <div className="font-size-14 font-weight-bold text-primary my-1 text-end">25’000₮</div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end mt-5">
                      <Button 
                        onClick={() => charge()}
                        className="bg-primary btn-bordered w-100 w-sm-auto" 
                        variant="contained"
                        disableElevation>
                        Захиалга өгөх
                      </Button>
                    </div>
                  </div>
                }
              </Col>
              {
              paymentStep != 0 && <Col lg={5} md={6} sm={6}>
                <div className="d-flex flex-column-reverse flex-sm-column mb-5 pb-3 me-0 me-md-4">
                  <div className="bordered bg-light p-4 mt-4">
                    <div className="font-size-16 font-weight-bold">Холбогдох мэдээлэл</div>
                    <div className="d-flex font-size-14 align-items-center mt-4">
                      <div className="icon-container ms-3">
                        <img alt="office" src="/images/contact.svg" height={12} />
                      </div>
                      7007 3001, 7007 3001
                    </div>
                    <div className="d-flex font-size-14 align-items-center mt-3">
                      <div className="icon-container ms-3">
                        <img alt="office" src="/images/time.svg" height={12} />
                      </div>
                      Да - Ба 09:00 - 18:00 
                    </div>
                    <div className="d-flex font-size-14 align-items-center mt-3">
                      <div className="icon-container ms-3">
                        <img alt="office" src="/images/mail.svg" height={10} />
                      </div>
                      info@shunkhlai@gmail.com
                    </div>
                    <div className="d-flex font-size-14 align-items-center mt-3">
                      <div className="icon-container ms-3">
                        <img alt="office" src="/images/mail.svg" height={10} />
                      </div>
                      <div>
                        4th floor, Capital house, Chinggis avenue, 976 Ulaanbaatar, Mongolia
                      </div>
                    </div>
                  </div>

                  <div className="warning-container mt-4">
                      <div>
                        Таны захиалсан карт 2-3 хоног хүлээгдэх тул та холбогдож мэдээлэл авах боломжтой.
                      </div>
                  </div>
                </div>
              </Col>
              }
            </Row>
          </div>
        } 
      </div>
      <SnackBar 
        showMessage={showMessage} 
        closeMessage={closeMessage}/>
    </>
  );
};

export default CardOrder;